import { Select } from 'Select';
import { type PreferenceSelectOption } from '../editPreferences.types';
import { SettingRow } from './SettingRow';

type Props = {
    title: string;
    description: string;
    value: string;
    options: PreferenceSelectOption[];
    onValueChange: (value: string) => void;
};

export function PreferenceSelectRow({ title, description, value, options, onValueChange }: Props) {
    return (
        <SettingRow title={title} description={description}>
            <Select
                options={options.map(option => ({ value: option.value, label: option.title }))}
                value={value}
                onValueChange={onValueChange}
                aria-label={title}
            />
        </SettingRow>
    );
}
